import { type RefObject, createContext } from 'react';

export const FocusContext = createContext<{
    register: (key: string, ref: RefObject<HTMLElement | null>) => void;
    unregister: (key: string) => void;
    setFocused: (key: string) => void;
    focusLast: () => void;
} | null>(null);
